import { render } from "./ProfilePanelButton.vue?vue&type=template&id=c5906f48&scoped=true"
import script from "./ProfilePanelButton.vue?vue&type=script&lang=js"
export * from "./ProfilePanelButton.vue?vue&type=script&lang=js"

import "./ProfilePanelButton.vue?vue&type=style&index=0&id=c5906f48&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5906f48"]])

export default __exports__